import root from '../root';

/**
 * Creates a debounced function that delays invoking `callback` until
 * after `delay` milliseconds have elapsed since the last time the
 * debounced function was invoked.
 *
 * @param {Function} callback - function to defer
 * @param {Number} delay - milliseconds to defer the function
 * @returns {Function}
 */
export default function debounce(callback, delay) {
  let timer;
  // generator function pattern
  return function debouncedCallback(...args) {
    const context = this;
    // restart the delay timer if another matching event comes in
    if (timer) root.clearTimeout(timer);
    // run the real listener code when the timer finally completes
    timer = root.setTimeout(() => {
      callback.apply(context, args);
    }, delay);
  };
}
